import styled from '@emotion/styled'

export const StyledPage = styled.div`
    display: flex;
    flex-direction: column;
    padding: 35px;
    gap: 35px;
`